import { z } from 'zod';
import { accountBadgeDistributionStatusSchema, } from '../entities/AccountBadgeEntityTypes';
export const editDistributionStatusBulkActionName = 'editDistributionStatus';
export const editDistributionStatusBulkActionRequestSchema = z.object({
    badgeId: z.string().uuid(),
    filter: z.custom(),
    distributionStatus: accountBadgeDistributionStatusSchema,
});
